/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { AbstractContactContext, AbstractContactVO, GroupedAbstractContactListVO } from '@well/domain';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable({
  providedIn: 'root'
})
export class DelContactEmailableResourceService extends AbstractResourceService<AbstractContactVO, any, any, any> {

  constructor(httpClient: HttpClient,
              environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('delContactEmailableUrl'),
      undefined,
      undefined
    );
  }

  findAllEmailableContactsForVendor(vendorUuid: string)
    : Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/vendor/${vendorUuid}`);
  }

  findAllEmailableContactsForVendors(vendorUuids: string[])
    : Observable<GroupedAbstractContactListVO[]> {
    return <Observable<GroupedAbstractContactListVO[]>>this.httpClient?.get(`${this.url}/vendor/list/${vendorUuids}`);
  }

  findAllEmailableContactsForCustomer(customerUuid: string)
    : Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/customer/${customerUuid}`);
  }

  findSupplierContactsForCustomerLegalEntity(legalEntityUuid: string)
    : Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/legal-entity/customer/${legalEntityUuid}`);
  }

  findSupplierContactsForServiceProviderLegalEntity(legalEntityUuid: string)
    : Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/legal-entity/service-provider/${legalEntityUuid}`);
  }

  findAllEmailablePublicContactsForLegalEntity(legalEntityUuid: string, context: AbstractContactContext | null)
    : Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/legal-entity/${context}/${legalEntityUuid}`);
  }

  findAllEmailableContactsForBusinessProfiles(businessProfileUuids: string[], context: AbstractContactContext)
    : Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/bp/${context}/list/${businessProfileUuids}`);
  }

  findAllEmailableContactsBasedOnBusinessProfile(businessProfileUuid: string, context: AbstractContactContext)
    : Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/bp/${context}/single/${businessProfileUuid}`);
  }

  getAllPublicContactsForCompany(legalEntityUuid: string) {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/legal-entity/both/${legalEntityUuid}`);
  }
}
